import React, { useState, useEffect } from 'react';
import ProfileSection from '../components/about/ProfileSection';
import SocialLinks from '../components/about/SocialLinks';
import Loading from '../components/common/Loading';
import { getAbout, getSettings } from '../services/content';
import './About.css';

const About = () => {
    const [content, setContent] = useState(null);
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadContent = async () => {
            try {
                const [aboutContent, settingsContent] = await Promise.all([
                    getAbout(),
                    getSettings()
                ]);
                setContent(aboutContent);
                setSettings(settingsContent);
            } catch (error) {
                console.error('Error loading about content:', error);
            } finally {
                setLoading(false);
            }
        };

        loadContent();
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="about-page">
            <ProfileSection content={content} />
            <SocialLinks settings={settings} />
        </div>
    );
};

export default About;